import React from 'react';
import PropTypes from 'prop-types';
import { LoadingOverlay } from '../../Share/components';

const propTypes = {
  children: PropTypes.element.isRequired,
};

function EmptyLayout(props) {
  return (
    <>
      <div className="tv-bg-login-page">
        <div className="tv-login-page__form-container">{props.children}</div>
      </div>
      <LoadingOverlay />
    </>
  );
}

EmptyLayout.propTypes = propTypes;

export default EmptyLayout;
